import { useDispatch, useSelector } from 'react-redux';
import {
  onCloseInsightDetails,
  onOpenInsightDetails,
} from '../../store/ui/uiSlice';
import type { RootState, AppDispatch } from '../../store';

export interface UseUiStoreReturn {
  // Properties
  isInsightDetailsOpen: boolean;
  insightDetailsContent: any;

  // Methods
  closeInsightDetails: () => void;
  openInsightDetails: (props: any) => void;
  toggleInsightDetails: () => void;
}

export const useUiStore = (): UseUiStoreReturn => {
  const dispatch: AppDispatch = useDispatch();

  const { isInsightDetailsOpen, insightDetailsContent } = useSelector(
    (state: RootState) => state.ui,
  );

  const openInsightDetails = (props: any): void => {
    dispatch(onOpenInsightDetails(props));
  };

  const closeInsightDetails = (): void => {
    dispatch(onCloseInsightDetails());
  };

  const toggleInsightDetails = (): void => {
    isInsightDetailsOpen ? openInsightDetails({}) : closeInsightDetails();
  };

  return {
    isInsightDetailsOpen,
    insightDetailsContent,
    closeInsightDetails,
    openInsightDetails,
    toggleInsightDetails,
  };
};
